/**
 * @exports PROFESSIONALS_IMAGE_HEADER
 * At URL_STATICS_IMAGES
 */
export const PROFESSIONALS_IMAGE_HEADER = 'coches/professionals/registro-profesionales-hero.jpg'

/**
 * @exports PROFESSIONALS_VALUE_PROPOSITION_IMAGES
 * At URL_STATICS_IMAGES
 */
export const PROFESSIONALS_VALUE_PROPOSITION_IMAGES = {
  ONE: 'coches/professionals/registro-profesionales-marca.jpg',
  TWO: 'coches/professionals/registro-profesionales-concesionario.jpg',
  THREE: 'coches/professionals/registro-profesionales-clientes.jpg'
}

/**
 * @exports PROFESSIONAL_PACKS
 * Images from URL_STATICS_IMAGES
 */
export const PROFESSIONAL_PACKS = [
  {
    NAME: 'LANDING_PROFESSIONALS.PACKS.START.NAME',
    DESCRIPTION: 'LANDING_PROFESSIONALS.PACKS.START.DESCRIPTION',
    IMAGE: 'coches/icons/professionals/start.svg'
  },
  {
    NAME: 'LANDING_PROFESSIONALS.PACKS.DISCOVER.NAME',
    DESCRIPTION: 'LANDING_PROFESSIONALS.PACKS.DISCOVER.DESCRIPTION',
    IMAGE: 'coches/icons/professionals/discover.svg'
  },
  {
    NAME: 'LANDING_PROFESSIONALS.PACKS.REFERENCE.NAME',
    DESCRIPTION: 'LANDING_PROFESSIONALS.PACKS.REFERENCE.DESCRIPTION',
    IMAGE: 'coches/icons/professionals/reference.svg'
  },
  {
    NAME: 'LANDING_PROFESSIONALS.PACKS.ADVANCE.NAME',
    DESCRIPTION: 'LANDING_PROFESSIONALS.PACKS.ADVANCE.DESCRIPTION',
    IMAGE: 'coches/icons/professionals/advance.svg'
  }
]

/**
 * @exports PROFESSIONALS_IMAGE_FOOTER
 * At URL_STATICS_IMAGES
 */
export const PROFESSIONALS_IMAGE_FOOTER = 'coches/professionals/registro-profesionales-footer.jpg'

/**
 * @exports PROFESSIONALS_FORM_CODE
 */
export const PROFESSIONALS_FORM_CODE = '62387a19-5bf6-e511-80da-4e7a3f64390a'
